import { useState, useLayoutEffect, useEffect } from 'react';
const useIsomorphicLayoutEffect = typeof document !== 'undefined' ? useLayoutEffect : useEffect;
export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(true);
    const [isTablet, setIsTablet] = useState(true);
    useIsomorphicLayoutEffect(() => {
        const handler = () => {
            const mobile = window.matchMedia('(max-width: 767px)').matches;
            setIsMobile(mobile);
            const tablet = window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches;
            setIsTablet(tablet);
        };
        handler();
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);
    return {
        isMobile,
        isTablet,
    };
}
